import React from "react";

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between mb-4">
      <div>
        <h2 className="text-lg font-semibold text-leechiuBlue normal-case tracking-normal">
          {title}
        </h2>
        {subtitle ? (
          <p className="mt-0.5 max-w-2xl text-xs text-gray-500">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
